<template>
  <div id="park">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <div class="content">
      <ul class="content_left">
        <li
            :class="curNav == item.id ? 'left_nav_active left_nav':'left_nav'"
            v-for="(item,index) in pageData.children" :key="item.id" @click="handleNav(item.id)">
          <router-link v-if="item.id == 4" :to="{path:'/location',query:{menuId:8,plateId:4}}">
            <span class="nav_name">地理位置</span>
          </router-link>
          <router-link v-else-if="item.id == 7" :to="{path:'/applyForEnter',query:{menuId:15,plateId:7}}">
            <span class="nav_name">申请入驻</span>
          </router-link>
          <router-link v-else :to="{path:'/articleList',query:{menuId:pageData.menuId,plateId:item.id}}">
            <span class="nav_name">{{item.plateName}}  &nbsp;</span>
            <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
            <img class="white" src="../assets/images/article/whiteRight.png" alt="">
          </router-link>
        </li>
        <p class="search_box">
          <input class="search" type="text" v-model="search">
          <router-link :to="{path:'/search',query:{menuId:pageData.menuId,plateId:curNav,search:this.search}}">
            <img class="search_img" src="../assets/images/article/search.png" alt="">
          </router-link>
        </p>
      </ul>
      <!--右-->
      <div class="content_right">
        <div class="content_header">
          <span class="title">申请入驻</span>
          <span class="card">入园申请 > 申请入驻</span>
        </div>
        <div class="form">
          <apply-form></apply-form>
        </div>
      </div>
    </div>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import ApplyForm from '@/components/ApplyForm.vue'
  import {queryArticleList, searchArticleList} from '@/api/ArticleList.js'
  import {queryArticleDetail} from '@/api/ArticleDetail.js'

  export default {
    name: 'ApplyForEnter',
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ApplyForm
    },
     data() {
       return {
         search: '',
       }
     },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      }
      ,
      curNav() {
        return this.$route.query.plateId
      }
      ,
      curName() {
        let name = this.pageData.children.find((item) => {
          return item.id == this.$route.query.plateId
        })
        return name
      }
    }
    ,
    created() {
    }
    ,
    methods: {
      handleNav(id) {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  //$themeColor: #3e76fc;
  #park {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    .content {
      width: 1200px;
      display: flex;
      margin-bottom: 150px;
      .content_left {
        width: 188px;
        background: url("../assets/images/article/listBg.png") no-repeat;
        .left_nav {
          a {
            width: 100%;
            height: 100%;
            display: inline-block;
            font-size: 16px;
            color: #333;
          }
          width: 160px;
          height: 40px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 40px;
          background-color: #fff;
          margin-top: 10px;
          cursor: pointer;
          position: relative;
          .nav_img {
            width: 7px;
            height: 11px;
          }
          .white {
            width: 7px;
            height: 11px;
            position: absolute;
            top: 16px;
            right: 4px;
            display: none;
          }
        }
        .left_nav_active {
          background-color: $themeColor;
          a {
            width: 100%;
            height: 100%;
            display: inline-block;
            color: #fff;
          }
          .nav_img {
            display: none;
          }
          .white {
            display: block;
          }
        }
        .left_nav:hover {
          background-color: $themeColor;
          a {
            color: #fff;
          }
          .nav_img {
            display: none;
          }
          .white {
            display: block;
          }
        }
        .left_nav:first-of-type {
          margin-top: 25px;
        }
        .search_box {
          position: relative;
          .search {
            width: 160px;
            height: 40px;
            margin-top: 25px;
            border-radius: 25px;
            border: 1px solid #ccc;
            padding-left: 10px;
          }
          .search_img {
            width: 22px;
            height: 21px;
            position: absolute;
            right: 34px;
            top: 34px;
          }
        }
      }
      .content_right {
        width: 1112px;
        padding-left: 34px;
        .content_header {
          width: 100%;
          height: 86px;
          border-bottom: 1px solid $themeColor;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 28px;
            color: $themeColor;
          }
          .card {
            font-size: 14px;
            color: #333;
          }
        }
        .form {
          width: 790px;
          height: 100%;
          padding: 0 10px;
          position: relative;
        }
      }
    }
  }
</style>

